import { useEffect } from 'react';
import 'aos/dist/aos.css';
import AOS from 'aos';

export const HeroSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, easing: 'ease-in-out', once: true, });
  }, []);

  return (
    <>
      <div className="row" style={{ maxWidth: "100%", margin: "auto" }}>
        <div className="col">
          <div className="card" data-aos="zoom-in" style={{ backgroundImage: 'url("LWWHero.jpg")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', }} >
            <div className="hero rounded" style={{ background: 'rgba(0,0,0, 0.65)', textAlign: 'center', padding: '18%', color: 'white', }} >
              <h1 style={{ color: 'red', fontFamily:"initial" }}>Lone Wolf Writes</h1>
              <h2 style={{fontFamily:"serif", fontSize:"larger"}}>Wolf With A Pen</h2>
              <br />
              <a href="/quotes" class="btn btn-dark" role="button" style={{ backgroundColor: 'transparent', border:"solid black 2px", padding: "1% 3%", borderRadius: '5px', marginTop: '10px', textDecoration: 'none', color: '#efefef' }} ><h4>- Quotes -</h4></a>
              <br /><br />
              <a href="/poems-eng" class="btn btn-info" role="button" style={{ backgroundColor: 'transparent', border:"solid black 2px", padding: "1% 3%", borderRadius: '5px', marginTop: '10px', textDecoration: 'none', color: '#efefef' }} ><h4>- Poems -</h4></a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
